module.exports = __webpack_public_path__ + "fonts/VetoSansCond-CondLight.6f67e64c.woff2";